// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".meta-item .wrapper[data-v-132c60a6]{align-items:center;display:flex;flex-direction:column;justify-content:baseline;white-space:normal}.meta-item svg[data-v-132c60a6]{color:#699c9a;font-size:1.625rem;line-height:1}.meta-item .description[data-v-132c60a6]{font-size:.875rem;letter-spacing:-.02rem;margin-top:.35rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
